import axios from "axios";

// Same-origin on any deployed domain (every domain routes /api to the backend), so no CORS or third-party cookies.
const { hostname, origin } = window.location;
const BASE = hostname === "localhost" || hostname === "127.0.0.1" ? process.env.REACT_APP_BACKEND_URL : origin;
export const API = `${BASE}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config;
    if (error.response?.status === 401 && !cfg._retry && !cfg.url.includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => (refreshing = null));
      try {
        await refreshing;
        return api(cfg);
      } catch {
        window.dispatchEvent(new Event("auth:expired"));
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

const usd = (cents) => (cents < 0 ? "-" : "") + "$" + (Math.abs(cents || 0) / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const money = (cents, currency) => {
  if (!currency || currency === "USD") return usd(cents);
  try { return new Intl.NumberFormat("en-US", { style: "currency", currency }).format((cents || 0) / 100); } catch { return `${usd(cents).replace("$", "")} ${currency}`; }
};

export const CATEGORIES = ["groceries", "restaurants", "utilities", "insurance", "subscriptions", "travel", "housing", "loans", "p2p", "other"];
export const EXCLUDED = ["payment", "transfer", "income"];
export const ALL_CATEGORIES = [...CATEGORIES, ...EXCLUDED];
const LABELS = { p2p: "transfers to people", payment: "card payment (excluded)", transfer: "own transfer (excluded)", income: "income (excluded)" };
export const catLabel = (c) => LABELS[c] || c;
export const isBankAccount = (a) => ["checking", "savings"].includes(a?.type);
export const CAT_COLORS = {
  groceries: "#0F766E", restaurants: "#D97706", utilities: "#2563EB", insurance: "#7C3AED",
  subscriptions: "#DB2777", travel: "#4F46E5", other: "#64748B", payment: "#94A3B8",
  housing: "#0891B2", loans: "#B91C1C", p2p: "#CA8A04", transfer: "#94A3B8", income: "#16A34A",
};
